import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MenuItem from '../MenuItem';
import { SupportingDocumentsIcon, UserIdIcon, UserManagementIcon } from '../../../bombiix-icon';
import SsoIcon from '../../../assets/bombiix-icons/SsoIcon';
import { isSsoProviderEnabled } from '../../../services/auth.service';

function SettingUrl() {
  const history = useHistory();
  const pathName = history?.location?.pathname;
  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    UserDetails: { isCompanyAdminLoggedIn, isSupLoggedIn, isSupplierUserLoggedIn, userInfo },
  } = reducer;
  const supplierId = userInfo?.userId;
  const [ssoConnected, setSsoConnected] = useState(false);
  const onSsoSettings = pathName?.includes('/settings/sso');

  /**
   * SSO is offered to every tenant, so the entry point itself is not gated — only
   * its connected indicator is. Refreshed on mount and whenever the SSO settings
   * page is entered or left, which is the only place the connection state can
   * change. Deliberately NOT keyed on every path change: these are rate-limited
   * endpoints, and refetching on each navigation exhausted the SSO budget during
   * ordinary browsing. The rail reads as connected when ANY provider is linked, so
   * a Google-only tenant gets the same indicator as a Microsoft one.
   */
  useEffect(() => {
    let cancelled = false;
    if (!isCompanyAdminLoggedIn) {
      setSsoConnected(false);
      return undefined;
    }
    Promise.all([isSsoProviderEnabled('microsoft'), isSsoProviderEnabled('google')])
      .then(([microsoftConnected, googleConnected]) => {
        if (!cancelled) {
          setSsoConnected(microsoftConnected || googleConnected);
        }
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [isCompanyAdminLoggedIn, onSsoSettings]);

  return (
    <ul>
      <MenuItem
        activeClassList={['/settings/account-details']}
        pathName={pathName}
        linkTo="/settings/account-details"
        IconComponent={UserIdIcon}
        titleKey="SETTING_URL.ACCOUNT_DETAILS"
      />

      {(isCompanyAdminLoggedIn || isSupLoggedIn) && (
        <MenuItem
          activeClassList={['/settings/user-library', 'user-groups']}
          pathName={pathName}
          linkTo="/settings/user-library"
          IconComponent={UserManagementIcon}
          titleKey="SETTING_URL.USER_MANAGEMENT"
        />
      )}

      {isCompanyAdminLoggedIn && (
        <MenuItem
          activeClassList={['/settings/sso']}
          pathName={pathName}
          linkTo="/settings/sso"
          IconComponent={SsoIcon}
          stateClass={ssoConnected ? 'menu-item--connected' : ''}
          titleKey="SETTING_URL.SSO"
        />
      )}

      {isSupLoggedIn && (
        <MenuItem
          activeClassList={['/settings/factories']}
          pathName={pathName}
          linkTo="/settings/factories"
          IconComponent={UserManagementIcon}
          titleKey="SETTING_URL.FACTORIES"
        />
      )}

      {(isSupLoggedIn || isSupplierUserLoggedIn) && (
        <MenuItem
          activeClassList={['/settings/supporting-docs']}
          pathName={pathName}
          linkTo={`/settings/supporting-docs/${supplierId}`}
          IconComponent={SupportingDocumentsIcon}
          titleKey="SETTING_URL.UPLOAD_SUPPORTING_DOCUMENTS"
        />
      )}
    </ul>
  );
}

export default SettingUrl;
